<template>
  <SortSearch default-sort="featured" dimension="FeaturedVectors" />
</template>

<script>
import SortSearch from '@/components/SortSearch';

export default {
  components: {
    SortSearch
  },
  nuxtI18n: {
    paths: {
      en: '/featured-vectors/p/:page',
      es: '/vectores-destacados/p/:page',
      pt: '/vetores-em-destaque/p/:page',
      de: '/featured-vectors/p/:page'
    }
  }
};
</script>
